import { useEffect } from "react";
import { useHubConnection } from "store/useHubConnection";
import { useOfferFileStore } from "store/useOfferFileStore";
import { useTaskFileStore } from "store/useTaskFileStore";
import { useValidationRequestFileStore } from "store/useRequestFileStore";
import { useTaskXtmQAStore } from "store/useTaskXtmQAStore";

const FileDownloadListener = () => {
  const hub = useHubConnection((state) => state.connection);
  const offerZipReady = useOfferFileStore((state) => state.onReadyToDownload);
  const taskZipReady = useTaskFileStore((state) => state.onReadyToDownload);
  const validationExecutionRequestZipReady = useValidationRequestFileStore((state) => state.onReadyToDownload);
  const qaReportReady = useTaskXtmQAStore((state) => state.onQAReportHubMessage);

  useEffect(() => {
    if (hub) {
      hub.off("PartnerOfferFullDownloadReady");

      // ready will be called when the web socket receives a message targeting OfferFullDownloadReady
      hub.on("PartnerOfferFullDownloadReady", offerZipReady);
    }
  }, [hub, offerZipReady]);

  useEffect(() => {
    if (hub) {
      hub.off("PartnerTaskFullDownloadReady");

      // ready will be called when the web socket receives a message targeting TaskFullDownloadReady
      hub.on("PartnerTaskFullDownloadReady", taskZipReady);
    }
  }, [hub, taskZipReady]);

  useEffect(() => {
    if (hub) {
      hub.off("PartnerValidationExecutionRequestFullDownloadReady");

      // ready will be called when the web socket receives a message targeting ValidationExecutionRequestFullDownloadReady
      hub.on("PartnerValidationExecutionRequestFullDownloadReady", validationExecutionRequestZipReady);
    }
  }, [hub, validationExecutionRequestZipReady]);

  useEffect(() => {
    if (hub) {
      hub.off("PartnerGenerateXtmQaReport");

      // ready will be called when the web socket receives a message targeting PartnerGenerateXtmQaReport
      hub.on("PartnerGenerateXtmQaReport", qaReportReady);
    }
  }, [hub, qaReportReady]);

  return <></>;
};

export default FileDownloadListener;
